import { Icon } from '@rsuite/icons';

import { coloursHex } from '../constants';

export const DisplayIconNoBorder = ({ icon }) => {
  return (
    <>
      {icon !== undefined ? (
        // @ts-expect-error - rsuite Icon props type rejects valid runtime values
        <Icon as={icon} color={coloursHex.default} size="2em" />
      ) : (
        ' '
      )}
    </>
  );
};
